import React from 'react'
import { components } from 'react-select'
export const Menu = props => {
  const { isMulti, handleApply, onChange } = props.selectProps
  const selectRef = props.selectProps.selectRef

  const closeMenu = () => {
    // Blurs the input to close the menu
    if (selectRef?.current) {
      selectRef.current.blur()
    }
  }
  return (
    <>
      <components.Menu {...props}>
        <div>
          <div>{props.children}</div>
          <div
            style={{ bottom: '0' }}
            className='d-flex multi-select-menu align-items-center position-sticky justify-content-between'
          >
            <button
              type='button'
              className='clear-options-btn'
              onClick={async () => {
                await onChange(isMulti ? [] : null)
                closeMenu()
              }}
            >
              Clear all
            </button>
            <button
              type='button'
              className={'apply-options-btn'}
              onClick={async () => {
                await handleApply(props.selectProps.value)
                closeMenu()
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </components.Menu>
    </>
  )
}
export const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <img src='/images/icons/caret-down.svg' alt='' />
      </components.DropdownIndicator>
    )
  )
}

export const MultiValueContainer = ({ children, getValue, ...props }) => {
  var values = getValue()
  const {
    menuIsOpen,
    placeholder,
    label,
    useLabelAsPlaceholder,
    isSearchable,
    inputValue,
    isMulti,
    hasDropdownControlMenu,
    isFocused,
    isAsync = false,
  } = props.selectProps || {}
  const shouldRenderPlaceholderSearchable = isAsync
    ? isSearchable && !isFocused
    : isSearchable
  return (
    <components.ValueContainer {...props}>
      {useLabelAsPlaceholder ||
      (isMulti && hasDropdownControlMenu && !isSearchable) ? (
        <>
          {!!values.length ? (
            <div className='select-multiple-value  label-as-placeholder'>
              <span className='label first-letter-cap'>
                {label?.toLowerCase()}
              </span>
              <span
                className={`selected-options-badge ${
                  values.length >= 10 ? 'larger-badge' : ''
                }`}
              >
                {values.length}
              </span>
            </div>
          ) : (
            <div className='react-select__placeholder first-letter-cap label text-truncate'>
              {useLabelAsPlaceholder
                ? label?.toLowerCase()
                : placeholder?.toLowerCase()}
            </div>
          )}
        </>
      ) : shouldRenderPlaceholderSearchable ? (
        /* Only show placeholder/badge when NO inputValue or I mean no search text */
        !!values.length && !inputValue ? (
          <div
            className='select-multiple-value label-as-placeholder'
            style={{
              position: 'absolute',
              left: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'none',
              zIndex: 1,
            }}
          >
            <span className='custom-value'>{placeholder}</span>
            <span
              className={`selected-options-badge ${
                values.length >= 10 ? 'larger-badge' : ''
              }`}
            >
              {values.length}
            </span>
          </div>
        ) : !values.length && !inputValue ? (
          <div className='react-select__placeholder searchable-multiple-select-custom-placeholder'>
            <span className='custom-value'>{placeholder}</span>
          </div>
        ) : null
      ) : (
        <>
          {!menuIsOpen && !!values.length && (
            <div className='select-multiple-value'>
              {values.map(({ label }) => label).join(', ')}
            </div>
          )}
          {!menuIsOpen && !values.length && (
            <div className='react-select__placeholder'>{placeholder}</div>
          )}
        </>
      )}
      {React.cloneElement(children[1])}
    </components.ValueContainer>
  )
}
